<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 307 85"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <path
      d="M166.011,78.628l-155.351,6.043l-10.661,-10.6l7.053,-64.562l12.738,-9.51c26.659,1.298 94.162,4.388 157.039,7.239l-0.681,4.491l8.54,1.294l0.817,-5.392c51.078,2.313 97.643,4.403 114.697,5.152l6.407,6.669c-0.814,12.14 -2.841,37.106 -3.649,48.619l-7.774,5.531l-120.39,4.683l0.676,-4.458l-8.54,-1.294l-0.924,6.094Zm16.046,-48.231l1.316,-8.686l-8.54,-1.294l-1.316,8.686l8.54,1.294Zm-2.633,17.373l1.316,-8.686l-8.54,-1.294l-1.316,8.686l8.54,1.294Zm-2.633,17.373l1.316,-8.686l-8.54,-1.294l-1.316,8.686l8.54,1.294Z"
      style="fill: #00ffc5"
    />
    <g>
      <path
        d="M22.408,61.457l6.513,-46.976l6.377,0.704l-6.513,47.04l-6.377,-0.768Zm13.297,-18.752l0.339,-4.48l19.945,-14.848l4.003,4.736l-17.231,12.864l16.349,16.256l-4.545,4.16l-18.86,-18.688Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M64.943,57.553l-2.578,-3.392l3.256,-22.784l2.849,-2.56l19.877,-1.536l3.121,1.6l5.766,10.752l-2.239,4.288l-21.098,4.16l-1.357,-5.824l17.028,-3.456l-2.849,-5.312l-15.196,1.088l-2.442,17.6l23.337,4.096l-1.221,5.888l-26.254,-4.608Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M133.19,59.217l-1.221,-1.344l-28.018,4.224l-3.663,-3.648l3.935,-14.656l3.053,-2.304l21.437,0l-1.425,-9.984l-24.422,5.632l-1.56,-5.824l27.882,-6.464l3.935,2.56l3.799,26.56l4.749,1.28l-1.696,5.76l-6.784,-1.792Zm-2.985,-7.232l-0.611,-4.416l-19.809,0l-2.103,7.808l22.523,-3.392Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M144.045,61.137l5.834,-38.656l6.309,0.768l-5.766,38.72l-6.377,-0.832Z"
        style="fill-rule: nonzero"
      />
    </g>
    <g>
      <path
        d="M192.444,58.36l2.077,-5.422l5.796,1.868l-2.077,5.468l-5.796,-1.914Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M202.973,55.717l2.222,-20.048l2.608,-1.868l15.504,2.369l-0.724,4.237l-13.089,-2.005l-1.739,15.082l16.132,-1.823l0.531,4.283l-18.981,2.096l-2.463,-2.324Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M227.074,58.496l4.154,-27.521l4.492,0.547l-4.105,27.566l-4.54,-0.592Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M256.294,54.578l-15.262,2.369l-2.656,-2.233l1.159,-18.408l4.54,0.228l-0.966,15.72l12.123,-1.823l1.014,-14.17l4.588,0.365l-1.063,14.899l4.105,2.324l-2.367,3.645l-5.216,-2.916Z"
        style="fill-rule: nonzero"
      />
      <path
        d="M265.084,55.99l1.835,-26.063l4.588,0.273l-0.58,7.655l14.345,1.185l2.077,2.278l-0.966,12.029l-1.787,1.914l-16.808,3.007l-2.705,-2.278Zm4.733,-2.415l12.171,-2.187l0.676,-8.247l-12.026,-1.048l-0.821,11.482Z"
        style="fill-rule: nonzero"
      />
    </g>
  </svg>
</template>
